export default function getSelectedPreview(selectedItem) {
  const phone = selectedItem.phoneCode && selectedItem.phoneNumber
    ? `${selectedItem.phoneCode}${selectedItem.phoneNumber}`
    : selectedItem.phone || '';
  const email = selectedItem.email || '';
  const emailText = email ? `<a class="sk-link sk-link--default preview js-copy-to-clipboard" href="mailto:${email}">${email}</a>` : '';
  const phoneText = phone ? `<a class="sk-link sk-link--default preview js-copy-to-clipboard" href="tel:${phone}">${phone}</a>` : '';
  return `${emailText}${phoneText}`;
}
